import React from "react";
import { Form, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { FieldHeader } from "../../components/FieldHeader";

function RadioWidget({ options, value, label, formContext }: any) {
  const { t } = useSchemaTranslation();

  // Generating a unique field name to identify this set of radio buttons
  const { enumOptions } = options;

  const inlineOption = options.inline ? { inline: true } : { grouped: true };
  const selectedOption = enumOptions.find((option: any) => value === option.value);
  return (
    <Form.Group {...inlineOption}>
      {label && (
        <Form.Field>
          <FieldHeader>{t(label)} </FieldHeader>
        </Form.Field>
      )}
      {selectedOption ? <Form.Field>{t(selectedOption.label)}</Form.Field> : <Form.Field>{formContext.emptyValue}</Form.Field>}
      {!label &&
        enumOptions.map((option: any) => {
          const selected = value === option.value;
          const icon = selected ? (
            <Icon name="check" />
          ) : (
            <Icon name="times" style={{ opacity: 0 }} />
          );
          return (
            <Form.Field disabled={!selected}>
              {icon} {t(option.label)}
            </Form.Field>
          );
        })}
    </Form.Group>
  );
}

RadioWidget.defaultProps = {
  options: {
    semantic: {
      inverted: false,
      fluid: true,
    },
  },
};

RadioWidget.propTypes = {
  options: PropTypes.object,
};

export default RadioWidget;
